import { Text, TextProps } from '@chakra-ui/react'
import { PropsWithChildren } from 'react'

// Section label — Charting UI Visual Design System (spec Section 0.6.5).
// 10px, weight 500, uppercase, sage green (#4a7c59), letter-spacing 0.08em, 7px bottom margin.
// Used as the heading above every encounter form section and read-only view section.
export const SectionLabel = ({ children, ...props }: PropsWithChildren<TextProps>) => (
  <Text
    as="span"
    display="block"
    fontSize="11px"
    fontWeight={600}
    color="#4a7c59"
    textTransform="uppercase"
    letterSpacing="0.08em"
    // mb="7px"
    {...props}>
    {children}
  </Text>
)
